





































// vendor
import { defineComponent, ref, computed, PropType } from "@vue/composition-api";
// project
import * as OpsAPI from "@/services/api/ops";
import * as StudyAPI from "@/services/api/studies";
import { Study } from "@/psychlab/types";
// import { Confirm, IConfirmModal } from "@/components.generic/utility-modal";
import { Dictionary } from "@/utils/types";
import * as AppModal from "@/AppModal";
// local
import { default as FoldoutCard } from "./foldout-card.vue";

export default defineComponent({
	props:{
		// study:{
		// 	type:Object as PropType<Study>,
		// 	required:true,
		// }
	},
	components: {
		// Confirm,
		FoldoutCard,
	},
	setup(props, context) {
		// state
		const foldoutState = ref<Dictionary<boolean>>({});
		// const confirmModal = ref<IConfirmModal>();
		const study = ref<Study>();
		// computed
		const routeId = computed(() => context.root.$route.params["groupId"]);

		const toggleFoldout = (name: string) => {
			const d = foldoutState.value;
			d[name] = !Boolean(d[name]);
			foldoutState.value = JSON.parse(JSON.stringify(d));
		};

		const openBlueprintRoute = () => {
			if (!study.value) {
				return;
			}
			context.root.$router.push({
				name: "studies",
				params: {  },
			});
		};

		const rebuildSessions = async () => {
			try {
				await OpsAPI.rebuildSessionState({ group: routeId.value });
				console.log("Rebuilt sessions.");
			} catch (err) {
				console.error(err.message);
			}
		};

		const rebuildChannels = async () => {
			try {
				await OpsAPI.rebuildDataChannels({ study: routeId.value });
				console.log("Rebuilt channels.");
			} catch (err) {
				console.error(err.message);
			}
		};

		const deleteStudy = async () => {
			// if (!confirmModal.value) { return; }
			AppModal.confirm(
				{
					title: "Delete Study",
					description: "This operation is irreversible. <br/> Are you sure?",
					variant:"danger",
					okText:"I Understand",
					cancelText:"Cancel",
				},
				async () => {
					try {
						await StudyAPI.deleteStudy(routeId.value);
						openBlueprintRoute();
					} catch (err) {
						console.log(err);
					}
				},
			);
		};

		const init = async () => {
			try {
				study.value = await StudyAPI.getStudy(routeId.value);
			} catch (err) {
				console.log(`Error loading study, id:'${routeId.value}'`);
			}
		};

		const runOperation = (name: string) => {
			switch (name) {
				case "rebuild-sessions":
					rebuildSessions();
					break;
				case "rebuild-channels":
					rebuildChannels();
					break;
				case "delete-study":
					deleteStudy();
					break;
			}
		};

		const ops = computed(() => foldouts);

		init();

		return {
			foldoutState,
			// confirmModal,
			ops,
			toggleFoldout,
			rebuildSessions,
			rebuildChannels,
			deleteStudy,
			runOperation,
		};
	},
});

type FoldoutContent = {
	name: string;
	icon: string;
	title: string;
	variant: string;
	buttonText: string;
	content: string;
};

const foldouts: FoldoutContent[] = [
	{
		name: "rebuild-sessions",
		icon: "mdi.refresh",
		title: "Rebuild Sessions",
		variant: "info",
		content: `<p>
		Rebuilding a session will refresh computed properties, and
		fill in missing values. This is useful if the database
		schema has changed and properties need to be regenerated or
		added for older data.
		</p>
		<p>
			<strong>Note:</strong> Only use this if you know what you're
			doing.
		</p>`,
		buttonText: "Rebuild Sessions",
	},
	// {
	// 	name: "rebuild-channels",
	// 	icon: "mdi.refresh",
	// 	title: "Rebuild Channel Data",
	// 	variant: "info",
	// 	content: `<p>
	// 	Refreshes computed properties for data channel values and
	// 	adds missing properties. This is useful if the database
	// 	schema has changed and properties need to be regenerated or
	// 	added for older data.
	// 	</p>
	// 	<p>
	// 		<strong>Note:</strong> Only use this if you know what you're
	// 		doing.
	// 	</p>`,
	// 	buttonText: "Rebuild Channel Data",
	// },
	{
		name: "delete-study",
		icon: "mdi.trash-can",
		title: "Delete Study",
		variant: "danger",
		content: `<p>
		This will permanently delete the Study, and all data
		associated with it, including user sessions.
		</p>`,
		buttonText: "Delete Study",
	},
];



